// extracted by mini-css-extract-plugin
export default {"heading-root":"Heading_heading-root__NTcen"};